<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="escPressed"
  >
    <md-dialog-title>
      <i :class="typeFa"> </i>
      {{ type | capitalize }}
    </md-dialog-title>
    <div class="md-dialog-content md-layout md-alignment-center-center progress-container" v-if="showProgressBar">
      <md-progress-spinner class="md-accent" :md-diameter="250" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div v-else class="md-dialog-content">
      <div>
        <div v-for="item in form">
          <div v-if="item.type === 'string'">
            <div class="md-layout-item md-small-size-100">
              <md-field v-if="isEditable.includes(item.model)">
                <label>{{ `${item.model}:` | snakeCase | capitalize }}</label>

                <md-input v-if="item.model === 'name'" v-model="name" :disabled="isReadOnly" />
                <md-input v-if="item.model === 'phone_number'" v-model="phone_number" :disabled="isReadOnly" />
                <md-input v-if="item.model === 'email_address'" v-model="email_address" :disabled="isReadOnly" />
              </md-field>
              <md-field v-else>
                <label>{{ `${item.model}:` | snakeCase | capitalize }}</label>
                <md-input v-model="dev[item.model]" disabled />
              </md-field>
            </div>
          </div>
          <!-- TODO:
            - // item.model !== 'admin' // should be delete later
          -->
          <div v-if="item.type === 'number' && item.model !== 'device_pk' && item.model !== 'admin'">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label>{{ `${item.model}:` | snakeCase | capitalize }}</label>
                <md-input v-model="dev[item.model]" disabled />
              </md-field>
            </div>
          </div>
          <div v-if="item.type === 'boolean'">
            <div class="md-layout-item md-small-size-100">
              <md-checkbox v-model="dev[item.model]" disabled> </md-checkbox>
            </div>
          </div>
          <div class="md-layout-item md-small-size-100" v-if="item.type === 'array'">
            <multi-value-input
              :value="dev[item.model]"
              is-disabled="true"
              :label="`${item.model}` | snakeCase | capitalize"
            ></multi-value-input>
          </div>
          <div class="md-layout md-layout-item md-small-size-100" v-if="item.type === 'object'">
            <div class="md-layout-item md-size-90" style="padding: 0">
              <md-field>
                <label>{{ `${item.model}:` | snakeCase | capitalize }}</label>
                <md-input v-model="dev[item.model].summary" disabled />
              </md-field>
            </div>

            <a
              class="md-layout md-layout-item md-size-10 md-alignment-center-center"
              @click.prevent="changeMode(dev[item.model])"
              style="cursor: pointer"
              v-if="dev[item.model].summary"
            >
              <md-icon>launch</md-icon>
            </a>
          </div>
        </div>
      </div>
      <div dir="rtl">
        <template v-if="isReadOnly">
          <md-button class="md-primary md-raised" @click="closeDialog">close </md-button>
          <md-button v-if="mode !== 'deviceDetails'" class="md-primary md-raised" @click="back">back </md-button>
        </template>
        <template v-else>
          <md-button class="md-primary md-raised" @click="closeDialog">close </md-button>
          <md-button v-if="mode === 'deviceDetails'" class="md-primary md-raised" @click="editDevice">save </md-button>
          <md-button v-else class="md-primary md-raised" @click="back">back </md-button>
        </template>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import MultiValueInput from "./MultiValueInput";

export default {
  name: "DeviceDetails",
  components: { MultiValueInput },
  props: ["show", "device", "application_user_pk"],
  data() {
    return {
      form: [],
      hardwareDetailsForm: [],
      typeFa: "",
      type: "",
      dev: {},
      isEditable: ["name", "email_address", "phone_number"],
      name: null,
      email_address: null,
      phone_number: null,
      fetchData: {},
      mode: "deviceDetails",
      showProgressBar: false
    };
  },
  methods: {
    changeMode: function(newDev) {
      this.form = [];
      this.dev = newDev;
      this.mode = "hardwareDetails";
    },
    back: function() {
      this.form = [];
      this.dev = Object.assign({}, this.device);
      this.mode = "deviceDetails";
    },
    closeDialog: function() {
      this.showProgressBar = false;
      this.form = [];
      this.$emit("close");
    },
    escPressed: function() {
      if (this.mode === "deviceDetails") this.closeDialog();
      else this.back();
    },
    editDevice: async function() {
      this.showProgressBar = true;
      this.form = [];
      const response = await this.$api.editDevice({
        params: this.fetchData
      });
      this.showProgressBar = false;
      this.$emit("save");
    }
  },
  computed:{
    isReadOnly() {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins") || !this.device.confirmed;
    },
  },
  watch: {
    device: function(newValue, oldValue) {
      // TODO maybe we need to copy the value
      this.name = newValue.name;
      this.dev = Object.assign({}, newValue);
    },
    dev: function(newValue, oldValue) {
      this.fetchData = {
        type: this.device.type,
        application_user_pk: this.application_user_pk,
        device_pk: this.device.device_pk
      };
      for (const [key, value] of Object.entries(newValue)) {
        if (key === "type_fa") {
          this.typeFa = value;
          continue;
        }
        if (key === "type") {
          this.type = value;
          continue;
        }
        let model = key;
        let type = typeof value;

        if (value === null) {
          this.dev[model] = "";
          type = typeof "";
        }
        if (key === "phone_number") {
          this.phone_number = value;
        }
        if (key === "email_address") {
          this.email_address = value;
        }

        if (type === "object") {
          if (Array.isArray(value)) {
            this.form.push({
              type: "array",
              model: model
            });
          } else {
            this.form.push({
              type: "object",
              model: model
            });
          }
        } else {
          this.form.push({
            type: type,
            model: model
          });
        }
      }
    },
    name: function(newValue, oldValue) {
      if (newValue) {
        this.fetchData.name = newValue;
      }
    },
    phone_number: function(newValue, oldValue) {
      if (newValue) {
        this.fetchData.phone_number = newValue;
      }
    },
    email_address: function(newValue, oldValue) {
      if (newValue) {
        this.fetchData.email_address = newValue;
      }
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    snakeCase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.replace(/_/gi, " ");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-list-item-text {
  position: relative;
}
.progress-container {
  padding: 32px;
  overflow: hidden;
}
</style>
